import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the Profile API.
 *
 * This file drives:
 * - **Enhanced API**: computed endpoint keys in `enhanceEndpoints`
 * - **Hook re-exports**: clean name → generated name mapping
 * - **MSW mock factories**: HTTP method + URL path pattern
 *
 * When the OpenAPI spec changes and codegen regenerates, update this
 * file to keep everything in sync.
 */

/**
 * Endpoint definitions keyed by clean export name.
 *
 * Each entry maps a human-friendly name to:
 * - `generated` — the codegen-produced RTK Query endpoint name, derived from the OpenAPI operationId
 * - `method` — HTTP verb
 * - `path` — URL pattern (MSW-compatible `:param` syntax)
 */
export const PROFILE_API_ENDPOINTS = {
  getProfile: {
    generated: 'profileControllerShowMeV1',
    method: 'get',
    path: '/api/v1/profile',
  },
  updateProfile: {
    generated: 'profileControllerUpdateMeV1',
    method: 'put',
    path: '/api/v1/profile',
  },
  listProfileTenants: {
    generated: 'profileControllerGetMyTenantsV1',
    method: 'get',
    path: '/api/v1/profile/tenants',
  },
  verifyTelegram: {
    generated: 'profileControllerVerifyTelegramV1',
    method: 'post',
    path: '/api/v1/profile/verify-telegram',
  },
} as const satisfies Record<string, EndpointDef>;

export type ProfileEndpointName = keyof typeof PROFILE_API_ENDPOINTS;
